import type { ReactNode } from 'react';
import type { SearchTypes } from '../../types';
import { JournalIcon, GroupUnitIcon, CalendarIcon, SchoolIcon } from '@bi-digital/icons';

import styles from './no-results.module.css';
import { useTranslation } from 'react-i18next';

const TypeToIconAndDescription: Record<Exclude<SearchTypes, 'All'>, { icon: ReactNode; description: string }> = {
    Articles: {
        icon: <JournalIcon aria-hidden='true' size='2xl' />,
        description: 'article.noResults',
    },
    Employees: {
        icon: <GroupUnitIcon aria-hidden='true' size='2xl' />,
        description: 'employee.noResults',
    },
    Events: {
        icon: <CalendarIcon aria-hidden='true' size='2xl' />,
        description: 'event.noResults',
    },
    Programmes: {
        icon: <SchoolIcon aria-hidden='true' size='2xl' />,
        description: 'programme.noResults',
    },
};

export type NoResultsProps = {
    type: Exclude<SearchTypes, 'All'>;
};

export const NoResults = ({ type }: NoResultsProps) => {
    const { t } = useTranslation();
    return (
        <div className={styles.noResults}>
            {TypeToIconAndDescription[type].icon}
            <p>{t(TypeToIconAndDescription[type].description)}</p>
        </div>
    );
};
